import Logo from '@tandem/ui/Тандем.svg?react'
import $ from './Splash.css'


export default function SplashLayout(props: { children: React.ReactNode }) {
  return (
    <div class={$.container}>
      <main>
        <Logo class={$.logo} />
        {props.children}
      </main>

      <footer>
        <small>© 2026 ООО «Тандем Ритейл»</small>
      </footer>
    </div>
  )
}
